export class GAnalyticsConstant {
    static readonly ANALTYICS_NOT_CONFIG: string = "Google analytics is not configured.";
    static readonly ANALTYICS_NOT_FORMAT: string = "The google analytics ID is not properly formatted.";
    static readonly GOOGLE_ANALYTICS_TRACKING_ID: string = "GOOGLE_ANALYTICS_TRACKING_ID";
    static readonly GOOGLE_MANAGER_URL: string = "https://www.googletagmanager.com/gtag/js?id=";
}